import { CheckingAccount } from "@app/models/CheckingAccount";
import { AchTokenRequest } from "@app/models/ftni/AchTokenRequest";
import { AchTokenResponse } from "@app/models/ftni/AchTokenResponse";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

export type {
    AchTokenRequest as FTNIAchTokenRequest,
    AchTokenResponse as FTNIAchTokenResponse,
};

@Injectable({
    providedIn: "root"
})
export class FTNIApi extends HOAApiBase implements FTNIApi {

    constructor() {
        super('FTNIApi')
    }

    /**
     * POST - FTNIController
     * Retrieve a list of contact points for the application\n
     */
    public privateProcessACHPost(checkingAccount: CheckingAccount): Observable<AchTokenResponse>  {
        let token = sessionStorage.getItem("hoapay_accessToken");
        const localVarPath =
            this.createUrl(this.getDigitalPaymentPath(), '/v1/' + (token ? 'registered/' : '') + 'ftni/achToken');

        let tokenRequest: AchTokenRequest = {
            routingNumber: checkingAccount.routingNumber,
            accountNumber: checkingAccount.accountNumber,
            customerName: checkingAccount.accountHolderName,
            bankName: checkingAccount.bankName,
            customerId: checkingAccount.payerId,
            bankAccountType: checkingAccount.savingsAccountIndicator
        };

        return this.http.post<AchTokenResponse>(localVarPath, tokenRequest);
    }

    public privateProcessACHPostUpdateToken(checkingAccount: CheckingAccount, bankToken: string): Observable<AchTokenResponse> {
        const localVarPath = this.createUrl(this.getDigitalPaymentPath(), '/v1/registered/ftni/achTokenUpdate');

        let tokenRequest: AchTokenRequest = {
            routingNumber: checkingAccount.routingNumber,
            accountNumber: "",
            customerName: checkingAccount.accountHolderName,
            bankName: checkingAccount.bankName,
            customerId: checkingAccount.payerId,
            bankAccountType: checkingAccount.savingsAccountIndicator,
            bankToken: bankToken
        };

        return this.http.post<AchTokenResponse>(localVarPath, tokenRequest);
    }
}

